"use client";

import { Modal, useModalStore } from "~/utils/stores/modalStore";
import React, { useEffect } from "react";

import CartModal from "../CartModal";
import { SearchModal } from "~/routes/searchModal/route";

export function Modals({
  locale,
  currencySymbol,
}: {
  locale?: string;
  currencySymbol?: string;
}) {
  useEffect(() => {}, []);

  const modals = useModalStore((s) => s.modals);

  return (
    <>
      {Object.entries(modals).map(([key, value]) => {
        return (
          <React.Fragment key={key}>
            {
              <ModalsFactory
                key={key}
                type={key as Modal}
                locale={locale ?? "se"}
                currencySymbol={currencySymbol ?? "SEK"}
              />
            }
          </React.Fragment>
        );
      })}
    </>
  );
}

function ModalsFactory({
  type,
  locale,
  currencySymbol,
}: {
  type: Modal;
  locale: string;
  currencySymbol: string;
}) {
  switch (type) {
    case "cart":
      return <CartModal locale={locale} currencySymbol={currencySymbol} />;
    case "search":
      return <SearchModal locale={locale} />;
    default:
      return null;
  }
}
